import Tools from '../../tools/Tools';

export default class Steps{
	constructor(view){
		console.log('Steps :: init',view);

		this.view 		= view;
		this.controls   = this.view.querySelector('.controls');
		this.prevBt     = this.controls.querySelector('.prev');
		this.nextBt     = this.controls.querySelector('.next');
		this.thx 		= view.querySelector('.thx');
		this.bar_steps 	= [];
		this.steps 		= [];
		
		this.view.querySelectorAll('.stepBar_step').forEach((bar_step,i) => {
			this.bar_steps.push(bar_step);

			bar_step.addEventListener('click', (e)=>{
				if(!e.currentTarget.classList.contains('disabled')){
					this.goTo(e,i);
				}
			});
		});

		this.view.querySelectorAll('.step').forEach(step => {
			this.steps.push(step);
		});
		
		this.current = 0;
	}

	prev(){
		if(this.current != 4 && this.current != 5) this.nextBt.classList.remove('hide');
		if(this.current <= 1)  this.prevBt.classList.add('hide');
		else this.prevBt.classList.remove('hide');

		if(this.current != 0){
			Tools.scrollTo(0,$(this.view.querySelector('.container')).offset().top - 40);
			this.bar_steps[this.current].classList.add('disabled');
			this.bar_steps[this.current].classList.remove('active');
			this.steps[this.current].classList.remove('active');
			this.current--;
			this.bar_steps[this.current].classList.add('active');
			this.bar_steps[this.current].classList.remove('disabled');
			this.steps[this.current].classList.add('active');
		}
	}

	next(last = false){
		if(!last){
			this.prevBt.classList.remove('hide');
			if(this.current != this.bar_steps.length - 1){
				Tools.scrollTo(0,$(this.view.querySelector('.container')).offset().top - 40);

				this.steps[this.current].classList.remove('active');
				this.bar_steps[this.current].classList.remove('active');
				this.current++;
				this.bar_steps[this.current].classList.add('active');
				this.bar_steps[this.current].classList.remove('disabled');
				this.steps[this.current].classList.add('active');
			}
		}else{
			this.thx.classList.add('active');
			this.steps[this.current].classList.remove('active');
		}
	}

	goTo(e,i){
		e.preventDefault();
		
		this.nextBt.classList.remove('hide');
		
		this.steps[this.current].classList.remove('active');
		this.steps[i].classList.add('active');
		this.bar_steps[this.current].classList.remove('active');
		this.bar_steps[i].classList.add('active');
		this.current = i;
		this.bar_steps.forEach((barStep,index) =>{
			if(this.current < index) barStep.classList.add('disabled');
		});

		if(this.current < 1) this.prevBt.classList.add('hide');
		else this.prevBt.classList.remove('hide');
	}

}